import * as React from 'react';
const TextItem = ({ text, style }) => React.createElement("div", { className: style }, text);
export default TextItem;
//# sourceMappingURL=TextItem.js.map